import { EFieldsStateActionTypes } from '../../actions/fieldsState';
import { IFieldsState } from '../../types/fieldsState';
import { TReduxActions } from '../../types/redux';
import { ERooms } from '../../types/rooms';

export const defaultState: IFieldsState = {
  address: null,
  district: null,
  moneyBalance: null,
  moneyToSpend: null,
  rentPrice: null,
  flatPrice: null,
  flatPriceChanged: false,
  flatPriceInc: null,
  rooms: ERooms.One,
};

export function fieldsStateReducer(state: IFieldsState = defaultState, action: TReduxActions): IFieldsState {
  switch (action.type) {
    case EFieldsStateActionTypes.SetFieldsState:
      return {
        ...state,
        ...action.payload,
      };
  }

  return state;
}
